import { Radio } from '@cimpress/react-components'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { AdvancedUserContainer } from '../../../common/components/AdvancedUserContainer'
import ContextMenu from '../../../common/components/ContextMenu'
import ContextMenuItem from '../../../common/components/ContextMenuItem'
import { TransitCalendarWithData } from '../transit-calendar-commons'
import styles from '../TransitCalendarView.module.css'

interface Props {
  selectedCalendar: TransitCalendarWithData | undefined
  transitCalendar: TransitCalendarWithData
  editable: boolean
  onChange: (transitCalendarId: string) => void
  onEdit: (calendarToEdit: TransitCalendarWithData) => void
}

export default function TransitCalendarLegendRow(props: Props) {
  const { t } = useTranslation()
  const history = useHistory()

  const onChange = (
    _: React.ChangeEvent<HTMLInputElement>,
    transitCalendarId: string
  ) => {
    props.onChange(transitCalendarId)
  }

  const onEdit = () => {
    props.onEdit(props.transitCalendar)
  }

  const goToHistory = () => {
    history.push(`/audits/calendar/${props.transitCalendar.calendarId}`)
  }

  const checked = props.selectedCalendar
    ? props.selectedCalendar.calendarId === props.transitCalendar.calendarId
    : undefined

  const labelText = props.transitCalendar.workingDaysCalendar.name || ''

  const label = checked ? (
    <span style={{ fontWeight: 600 }}>{labelText}</span>
  ) : (
    labelText
  )

  return (
    <div
      key={props.transitCalendar.calendarId}
      className={`flex ${styles.rowHeight}`}
    >
      <Radio
        onCheck={onChange}
        checked={
          props.selectedCalendar
            ? props.selectedCalendar.calendarId ===
              props.transitCalendar.calendarId
            : undefined
        }
        value={props.transitCalendar.calendarId}
        className={styles.transitCalendarRow}
        label={label}
      />
      <ContextMenu className={styles.transitCalendarRowContext}>
        <ContextMenuItem onClick={onEdit} label={t('calendars.showDetails')} />
        {props.editable && (
          <ContextMenuItem
            onClick={onEdit}
            label={t('calendars.editCalendar')}
          />
        )}
        <AdvancedUserContainer>
          <ContextMenuItem
            onClick={goToHistory}
            label={t('common.viewHistory')}
          />
        </AdvancedUserContainer>
      </ContextMenu>
      <div className={styles.transitCalendarRowScrollbar} />
    </div>
  )
}
